import { addDays, startOfWeek } from "date-fns";

export const weekdayKeys = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const;

export function getWeek(date: Date) {
  const monday = startOfWeek(date, { weekStartsOn: 1 });
  return Array.from({ length: 7 }, (_, index) => addDays(monday, index));
}

export const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const timezones = [...new Set([
  systemTimezone,
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Anchorage",
  "Pacific/Honolulu",
  "Asia/Taipei",
])];

export function timezoneOffset(timeZone: string, date: Date) {
  const offset = new Intl.DateTimeFormat("en", {
    timeZone,
    timeZoneName: "shortOffset",
  }).formatToParts(date).find(part => part.type === "timeZoneName")!.value;
  return offset.replace("GMT", "UTC");
}
